module.exports = __webpack_public_path__ + "static/img/5.675ae62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-hogar/5.png
// module id = PUlA
// module chunks = 0